export const ERROR_PATH = "*";
export const HOME_PATH = "/";
export const INTERNAL_PROJECTS_PATH = "/internalprojects";
export const ABOUT_PATH = "/aboutus";
export const HUMANITARIAN_CASES_PATH = "/humanitariancases";
export const ORPHAN_SPONSORSHIP_PATH = "/orphansponsorship";
export const NEWS_PATH = "/news";
export const LOGIN_PATH = "/login";
export const REGISTER_PATH = "/register";
export const NEWS_DETAILS_PATH = "/newsDetails";
export const ORGANIZATIONAL_STRUCTURE_PATH = "/organizationalstructure";
export const SEASONAL_PROJECTS_PATH = "/seasonalprojects";
export const VIDEOS_PATH = "/videos";
export const BOARD_OF_DIRECTORS_PATH = "/boardofdirectors";
export const DONATIONS_PATH = "/donations";
export const OUR_ACHIEVEMENTS_PATH = "/ourachievements";
export const VISION_AND_MISSION_PATH = "/visionandmission";
export const CONTACT_US_PATH = "/contactus";
export const SPEACH_PAGE_PATH = "/speachpage";
export const PRIVACY_POLICY_PATH = "/privacypolicy";
export const INTERNAL_SEASONAL_DETAILS = "/internalseasonalDetails";
export const HUMAN_PROJECT_DETAILS_PATH = "/humanprojectdetails";
export const RECENT_PROJECT_DETAILS_PATH = "/recentprojectdetails";
export const DONATIONS_WAYS_PATH = "/donationsways";
export const TERMS_PATH = "/termsandconditions";
export const TRANSACTION_PATH = "/transaction";
export const EXTERNAL_PROJECTS_PATH = "/externalprojects";
export const EXTERNAL_PROJECTS_DETAILS_PATH = "/externalprojectsdetails";
export const HELP_REQUEST_PATH = "/helprequest";
export const DASHBOARD_PATH = "/dashboard";
